import { RestService, Rest } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { HarvestActivityReportDto, HarvestActivityReportsApprovedOrRejectedInputDto, HarvestActivitySyncDto, SynchronizationOutputDto } from '../dtos/models';

@Injectable({
  providedIn: 'root',
})
export class HarvestActivityReportService {
  private readonly restService = inject(RestService);
  apiName = 'Default';
  

  getHarvestActivityReportsApprovedOrRejectedByInput = (input: HarvestActivityReportsApprovedOrRejectedInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, HarvestActivityReportDto[]>({
      method: 'GET',
      url: '/harvest-activity-report',
      params: { from: input.from, to: input.to },
    },
    { apiName: this.apiName,...config });
  

  getHarvestsActivityReportWithPendingApproval = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, SynchronizationOutputDto<HarvestActivitySyncDto>>({
      method: 'GET',
      url: '/harvest-activity-report/for-approval',
    },
    { apiName: this.apiName,...config });
}